'use strict';

var modalServiceModule = angular.module('t2g.common.services.modalServiceNew', []);

module.exports = modalServiceModule;

var TEMPLATE_BASE = '/app/modules/';

var APPOINTMENT_TYPES = {
  customer: {
    template: 'calendar/CustomerAppointmentLayoverView.html',
    controller: 'CustomerAppointmentModalCtrl as AppointmentModalCtrl',
  },
  course: {
    template: 'calendar/CourseAppointmentLayoverView.html',
    controller: 'CourseAppointmentModalCtrl as AppointmentModalCtrl',
  },
  private: {
    template: 'calendar/PrivateAppointmentLayoverView.html',
    controller: 'PrivateAppointmentModalCtrl as AppointmentModalCtrl',
  },
};

modalServiceModule.factory('ModalService', function(ModalFactory) {
  return {
    openAppointmentModal: openAppointmentModal,
    openServiceModal: openServiceModal,
  };

  function openServiceModal(service, closeCallback) {
    var modalInstance = ModalFactory.open({
      template: TEMPLATE_BASE + 'service/modal/NewServiceModal.html',
      controller: 'ServiceModalCtrlNew as ServiceModalCtrlNew',
      resolve: {
        service: function() {
          return service;
        },
        subscription: function(SubscriptionDA) {
          return SubscriptionDA.get();
        },
        office: function($q, OfficeModel) {
          var deferred = $q.defer();

          OfficeModel.get(function(error, office) {
            if (error) {
              deferred.reject(error);
            } else {
              deferred.resolve(office);
            }
          });

          return deferred.promise;
        },
        tariffServices: function(Tarif590DA) {
          return Tarif590DA.list();
        },
        objects: function($q, ObjectModel) {
          var deferred = $q.defer();

          ObjectModel.get(function(error, office) {
            if (error) {
              deferred.reject(error);
            } else {
              deferred.resolve(office);
            }
          });

          return deferred.promise;
        },
      },
    });

    modalInstance.closed.then(closeCallback);
  }

  function openAppointmentModal(appointment, closeCallback) {
    var type = _.get(appointment, 'type', 'customer');
    var appointmentTypeSettings = APPOINTMENT_TYPES[type];

    var modalInstance = ModalFactory.open({
      template: TEMPLATE_BASE + appointmentTypeSettings.template,
      controller: appointmentTypeSettings.controller,
      resolve: {
        customLabels: function(IndustrySpecific) {
          return IndustrySpecific.getLabels();
        },
        customers: function(CustomerDA) {
          return CustomerDA.list();
        },
        services: function($q, OfficeModel) {
          var deferred = $q.defer();
          var services = [];

          OfficeModel.get(function(error, office) {
            if (error) {
              deferred.reject(error);
            } else {
              _.forEach(office.serviceGroups, function(group) {
                _.forEach(group.services, function(service) {
                  service.group = group.name;
                });

                services = services.concat(group.services);
              });

              deferred.resolve(services);
            }
          });

          return deferred.promise;
        },
        appointment: function(AppointmentDA) {
          if (appointment && appointment._id) {
            return AppointmentDA.get(appointment._id);
          } else {
            var mergedAppointment = {};
            var start = new Date();
            start.setMinutes(0);
            start.setSeconds(0);
            var defaultAppointment = {
              type: 'customer',
              start: start,
              end: moment(start)
                .add(1, 'hour')
                .toDate(),
              recurring: {
                enabled: false,
              },
              reminder: {
                email: {
                  enabled: false,
                },
                sms: {
                  enabled: false,
                },
              },
              createdBy: 'coach',
            };

            _.merge(mergedAppointment, defaultAppointment, appointment);

            if (mergedAppointment.type === 'customer') {
              mergedAppointment.services = mergedAppointment.services || [];
              mergedAppointment.price = mergedAppointment.price || 0;
            } else if (mergedAppointment.type === 'course') {
              mergedAppointment.participants = mergedAppointment.participants || [];
              mergedAppointment.membershipSettings = mergedAppointment.membershipSettings || [];
            }

            mergedAppointment.start = new Date(mergedAppointment.start);
            mergedAppointment.end = new Date(mergedAppointment.end);

            return mergedAppointment;
          }
        },
        resources: function(ResourceDA) {
          var groupedResources = {
            employees: [],
            rooms: [],
          };

          return ResourceDA.list().then(function(response) {
            _.forEach(response.resources, function(resource) {
              if (resource.type === 'room') {
                groupedResources.rooms.push(resource);
              } else {
                groupedResources.employees.push(resource);
              }
            });

            return groupedResources;
          });
        },
        office: function(OfficeDA) {
          return OfficeDA.get();
        },
      },
    });

    modalInstance.closed.then(closeCallback);

    return modalInstance; // we should be able to close this modal outside
  }
});



// WEBPACK FOOTER //
// ./src/app/common/services/ModalServiceNew.js